import { Grid } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import UploadForm from '../../../../bedManagement/IpdVisit/IpdSummary/Tricog/UploadForm'
import { getOpdEcgReport } from '../../../../../services/TricogService'
import { useParams } from 'react-router-dom'
import { getEcgFile } from '../Constant'

const Tricog = () => {
  const [data, setData] = useState<any>({})
  const { id }: any = useParams()

  const getEcgReport = useCallback(async () => {
    const response = await getOpdEcgReport(id)
    if (response?.success) {
      const ecgData = response?.data?.[0]
      const fileData = await getEcgFile(ecgData?.ecgReportFileName)
      setData({
        ...ecgData,
        ...fileData, // contains pdfFile and pdfFileUrl
      })
    }
  }, [id])

  useEffect(() => {
    getEcgReport()
  }, [getEcgReport])

  return (
    <Grid container>
      <Grid xs={8}>
        <UploadForm
          screen='opd'
          data={{
            role: data?.role,
            name: data?.name,
            interpretation: data?.interpretation,
            pdfFile: data?.pdfFile,
            pdfFileUrl: data?.pdfFileUrl,
          }}
        />
      </Grid>
    </Grid>
  )
}

export default Tricog
